import type { TMessages } from '@/types/TMessages'

export const messages = {
  noValue: '-',
} satisfies TMessages
